export const CounsellorsConstants = {
    GETCOUNSELLORS_REQUEST : 'GETCOUNSELLORS_REQUEST',
    GETCOUNSELLORS_SUCCESS : 'GETCOUNSELLORS_SUCCESS',
    GETCOUNSELLORS_FAILURE : 'GETCOUNSELLORS_FAILURE',

    CREATECOUNSELLORS_REQUEST : 'CREATECOUNSELLORS_REQUEST',
    CREATECOUNSELLORS_SUCCESS : 'CREATECOUNSELLORS_SUCCESS',
    CREATECOUNSELLORS_FAILURE : 'CREATECOUNSELLORS_FAILURE',

    SELECTED_COUNSELLOR: 'SELECTED_COUNSELLOR',
    RESET_COUNSELLOR:'RESET_COUNSELLOR' 
}


// WEBPACK FOOTER //
// ./src/store/constants/counsellors.constants.js